import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type MbmAlertType = 'error' | 'success';

@Component({
  selector: 'mbm-alert',
  imports: [TranslateModule],
  templateUrl: './mbm-alert.component.html',
  styleUrl: './mbm-alert.component.scss',
})
export class MbmAlertComponent {
  readonly iconSrc = input<string | null>(null);
  readonly messageKey = input.required<string>();
  readonly showIcon = input<boolean>(true);
  readonly type = input<MbmAlertType>('error');

  protected readonly alertClass = computed(() => `mbm-alert mbm-alert-${this.type()}`);
  protected readonly useIconContainer = computed(() => this.type() === 'error');
  protected readonly resolvedIconSrc = computed<string | null>(() => {
    if (!this.showIcon()) return null;
    const src: string | null = this.iconSrc();
    if (src) return src;
    return this.type() === 'error' ? 'assets/icons/alert-error.svg' : 'assets/icons/alert-success.svg';
  });
}
